import includes from 'lodash/includes';
import kebabCase from 'lodash/kebabCase';
import { ReviewOut } from '../../store/api';

type Props = {
    readonly reviews: ReviewOut[] | undefined;
    readonly types: ReadonlyArray<string>;
};

export const ProductReviews = ({ reviews = [], types }: Props) => {
    const filteredReviews = reviews.filter(review => includes(types, review.reviewType));

    return (
        <div>
            {filteredReviews.map((review, index) => {
                const typeClassName = `review ${kebabCase(review.reviewType)}`;

                return (
                    <div key={typeClassName + index} className={typeClassName}>
                        {review.content}
                        <span className="source">{review.reviewSource}</span>
                    </div>
                );
            })}
        </div>
    );
};
